// extracted by mini-css-extract-plugin
module.exports = {"about-container":"AboutMe_about-container__3x_Pf","about-avatar":"AboutMe_about-avatar__2MeCu","about-content":"AboutMe_about-content__2tVVL"};